// Lib
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { navigateToBoard } from '../../reducers/navigationActions';

// Selectors
import { getCurrentBoardId } from '../../reducers/currentBoardId/currentBoardIdSelector';

type Props = {
    dispatchModalClose?: () => void;
    children?: React.ReactElement | null;
    preventNavigationToBoard?: boolean;
};

const ModalManager: React.FC<Props> = ({ dispatchModalClose, children, preventNavigationToBoard }) => {
    const currentBoardId = useSelector(getCurrentBoardId);
    const dispatch = useDispatch();

    const closeModalAndNavigate = () => {
        dispatchModalClose && dispatchModalClose();

        if (preventNavigationToBoard) return;

        dispatch(navigateToBoard({ boardId: currentBoardId, trackTiming: false }));
    };

    if (!children) return null;

    return React.cloneElement(children, {
        close: closeModalAndNavigate,
    });
};

export default ModalManager;
